// iconHelpers.tsx
import React from "react";
import {
  Board,
  Person,
  Status,
  Counter,
  Calendar,
  Email,
  Mobile,
  Dropdown,
  TextCopy,
  Favorite,
  Link,
  LongText,
  Timeline,
  File,
  Checkbox,
  Connect,
  Location,
  Tags,
  MondayDoc,
  Time

} from "@vibe/icons"; // Add more icons as needed

// Helper function to select icon based on column type
export const getColumnIcon = (type: string, size: number = 16, color: string = "#676879") => {
  switch (type) {
    case "person":
    case "people":
    case "multiple-person":
      return <Person size={size} color={color} />;
    case "status":
      return <Status size={size} color={color} />;
    case "numbers":
      return <Counter size={size} color={color} />;
    case "date":
      return <Calendar size={size} color={color} />;
    case "email":
      return <Email size={size} color={color} />;
    case "phone":
      return <Mobile size={size} color={color} />;
    case "dropdown":
      return <Dropdown size={size} color={color} />;
    case "text":
      return <TextCopy size={size} color={color} />;
    case "rating":
      return <Favorite size={size} color={color} />;
    case "link":
      return <Link size={size} color={color} />;
    case "long_text":
      return <LongText size={size} color={color} />;
    case "timeline":
      return <Timeline size={size} color={color} />;
    case "file":
      return <File size={size} color={color} />;
    case "checkbox":
      return <Checkbox size={size} color={color} />;
    case "board_relation":
      return <Connect size={size} color={color} />;
    case "location":
      return <Location size={size} color={color} />;
    case "tags":
      return <Tags size={size} color={color} />;
    case "doc":
      return <MondayDoc size={size} color={color} />;
    case "hour":
      return <Time size={size} color={color} />;
    default:
      return <Board size={size} color={color} />;
  }
};

export const getColumnBgColor = (type: string) => {
  switch (type) {
    case "person":
    case "people":
    case "text":
    case "link":
      return "bg-[#65ccfd]";
    case "status":
    case "dropdown":
    case "date":
      return "bg-[#00c875]";
    case "numbers":
    case "checkbox":
    case "email":
    case "phone":
    case "rating":
      return "bg-[#ffcb00]";
    case "doc":
    case "long_text":
      return "bg-[#5458df]";
    case "tags":
    case "timeline":
      return "bg-[#9d50dd]";
    case "file":
    case "board_relation":
      return "bg-[#ff7474]";
    case "location":
      return "bg-[#ff6b6b]";
    case "hour":
      return "bg-[#ff6b6b]";
    default:
      return "bg-[#676879]";
  }
};
